export default __webpack_public_path__ + "static/AdvertisementBanner-f0479115bbae3c76cef1492011b96507.jpg";